import './FaqPart.scss'

import React, { FunctionComponent } from 'react'
import { useEditorStatus } from 'Root/Shared/utils/edit/useEditorStatus'
import { getLocalizedUrl } from 'Root/Shared/utils/localeURL'
import PuxLink from 'Root/Shared/utils/PuxLink'
import PuxWysiwyg, {
  PuxWysiwygHtmlBodyType,
} from 'Shared/components/PuxWysiwyg/PuxWysiwyg'
import PuxStructuredData from '../../PuxStructuredData/PuxStructuredData'
import { t } from 'ttag'
import PuxIcon from '../../PuxIcon/PuxIcon'

export interface FaqPartType {
  contentType: 'EasySoftwareFaq'
  contentItemId: string
  displayText: string
  createdUtc: string
  faqAnswer: PuxWysiwygHtmlBodyType
  faqGroupName?: string
  path: string
}

function getFaqJson(item: FaqPartType) {
  const cleanAnswer = item.faqAnswer?.html?.replace(/<[^>]*>/g, '') ?? '';
  const prefixUrl = process.env.GATSBY_WEBSITE_URL ?? ""

  const json =
  {
    "@context": "https://schema.org",
    "@type": "QAPage",
    mainEntity: {
      "@type": "Question",
      name: item.displayText,
      text: item.displayText,
      datePublished: item.createdUtc,
      answerCount: 1,
      author: {
        "@type": "Organization",
        name: "EasySoftware",
        url: prefixUrl
      },
      acceptedAnswer: {
        "@type": "Answer",
        text: cleanAnswer,
      },
    }
  }

  return json
}

const FaqPart: FunctionComponent<FaqPartType> = (props) => {
  const isEditor = useEditorStatus()

  if (isEditor) {
    return (
      <>
        <PuxStructuredData structuredData={getFaqJson(props)} />
        <div className='pux-repeater-item FaqPart-wrapper'>
          <div className='FaqPart-item'>
            <div className="FaqPart-question">
              <PuxLink to={`${getLocalizedUrl(props.path)}`}>
                {props.displayText}
              </PuxLink>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <PuxStructuredData structuredData={getFaqJson(props)} />
      <details className='pux-repeater-item FaqPart-wrapper' name={props.faqGroupName}>
        <summary className='FaqPart-question'>
          <span className='FaqPart-dropdown'>
            <span className='FaqPart-dropdownText'>{props.displayText}</span>
            <span className='FaqPart-icon'>
              <PuxIcon
                name='arrows/down-arrow'
                size={12}
                decorative
              />
            </span>
          </span>
        </summary>
        <div className='FaqPart-item'>
          <div className='FaqPart-answerWrap'>
            <div className='FaqPart-answer'>
              <PuxWysiwyg content={props.faqAnswer} wysiwygId={props.contentItemId} inline />
              <div className={`FaqPart-openDetail`}>
                <PuxLink className='FaqPart-link' to={`${getLocalizedUrl(props.path)}`}>
                  {t`Redmine.Faq.ShowDetail`}
                  <PuxIcon name='arrows/arrow-right' size={24} decorative />
                </PuxLink>
              </div>
            </div>
          </div>
        </div>
      </details>
    </>
  )
}

export default FaqPart
